import * as R from 'ramda'
import {
  all,
  call,
  select,
  fork,
  take,
  takeEvery,
  takeLatest,
  put,
} from 'redux-saga/effects'

import injectSagas from 'helpers/injectSagas'

import {
  createTakeEveryName,
} from 'helpers/SagaUtil'

import {
  displayError
} from 'helpers/validator'

import {
  riskSelector
} from './selectors'

import {
  DISPATCH_ADD_RISK_CHECK,
  DISPATCH_REMOVE_RISK_CHECK,
  UPDATE_VALIDATION_VALUE,
} from './constants'

import {
  dispatchAddRiskCheck,
  dispatchRemoveRiskCheck,
  addRiskCheckStart,
  addRiskCheckSuccess,
  addRiskCheck,
  removeRiskCheckStart,
  removeRiskCheckSuccess,
  removeRiskCheck,
  updateValue
} from './actions'

function* addRisk(action) {
  const { id } = action
  yield put(addRiskCheckStart())
  yield put(addRiskCheck(id))
  yield put(addRiskCheckSuccess())
  yield fork(updateRisk)
}

function* removeRisk(action) {
  const { id } = action
  yield put(removeRiskCheckStart())
  yield put(removeRiskCheck(id))
  yield put(removeRiskCheckSuccess())
  yield fork(updateRisk)
}

function* updateRisk() {
  const risk = yield select(riskSelector)
  yield put(updateValue(risk))
}

function* watchAddRiskCheck() {
  yield takeEvery(DISPATCH_ADD_RISK_CHECK, addRisk)
}

function* watchRemoveRiskCheck() {
  yield takeEvery(DISPATCH_REMOVE_RISK_CHECK, removeRisk)
}

function* watchRisks() {
  yield all([
    fork(watchAddRiskCheck),
    fork(watchRemoveRiskCheck),
  ])
}

const withRiskValidationSagas = R.curry((validations, pathName, elementId, valueSelector) =>  {
  const path = `${pathName}.${elementId}.values`

  const takeEveryName = createTakeEveryName(path)

  function* runValueValidations() {
    let value = yield select(valueSelector)
    const error = displayError(value, validations)

    yield error
      ? put(dispatchAddRiskCheck(elementId))
      : put(dispatchRemoveRiskCheck(elementId))
  }

  function* watchValueChange() {
    yield takeEveryName(UPDATE_VALIDATION_VALUE, runValueValidations)
  }

  function* sagas() {
    yield all([
      fork(watchValueChange),
    ])
  }

  return injectSagas({ [`risk_${path}`]: sagas })
})

export {
  watchRisks,
  withRiskValidationSagas
}
